module.exports = __webpack_public_path__ + "img/01-as-ktirio.f06089c1.jpg";